import { FunctionComponent, useEffect, useState } from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import { useCompareParams } from '../../pages/compare/CompareContent';
import CompareTable, { PartSection, partsToPartSections } from './CompareTable';
import { UniversityPart } from '../../../../networking/repos/UniversityRepository';
import CompareTitle from './CompareTitle';
import Breadcrumbs from '../../../utils/Breadcrumbs';
import { compareColors } from '../../../../config/theming';
import {useUniversityFindQueryConfig} from '../../../query/University/Query';

interface Props {
    parts: UniversityPart[];
}

const CompareSectionsPage: FunctionComponent<Props> = ({ parts }) => {
    const [universityIds, compareIds] = useCompareParams();
    const [sections, setSections] = useState<PartSection[]>([]);

    const [universityConfig] = useUniversityFindQueryConfig(universityIds);
    const universityQuery = useQuery(universityConfig);

    useEffect(() => {
        setSections(partsToPartSections(parts));
    }, [parts]);

    const universities = universityQuery.data ?? [];

    return (
        <Page className={'compare-page'}>
            <CompareTitle colors={compareColors} universities={universities} />

            <div className={'compare-page__content'}>
                <Breadcrumbs
                    breadcrumbs={
                        [
                            { name: "Home", url: "/" },
                            { name: "Universities", url: "/universities" },
                            { name: "Compare", url: `/compare/${compareIds}` },
                            { name: sections[0]?.title, url: `/compare/${compareIds}/${sections[0]?.title}` }
                        ]
                    }
                />
                {sections.map((section, i) => (
                    <div className={'compare-program-page__section'} key={i}>
                        <h4 className={'compare-facilities-page__title'}>{section.title}</h4>

                        <div className={'compare-page__tables'}>
                            {section.parts.map((part, i) => (
                                <div className={'compare-page__table'} key={i}>
                                    <CompareTable colors={compareColors} part={part} />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </Page>
    );
};

export default CompareSectionsPage;
